import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './Header.module.css';

import SimpleBar from 'simplebar-react';
import useSimpleBar from '../../hooks/useSimpleBar';

import { Link } from 'react-router-dom';
import Logo from '../Logo';
import Progress from '../Progress';
import Navigation from '../Navigation';
import { HONORIFIC_SUFFIX, LOGOUT } from '../../constants';

import { isMobile } from '../../utils/util';
import {
  deleteAllTokens,
  getAccessToken,
  setLocalStorage,
} from '../../utils/storage';

import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { selectUser } from '../../features/authSlice';
import { apiSlice, useLogoutMutation } from '../../services/api';
import { persistor } from '../../services/store';

import ConditionalWrapper from '../ConditionalWrapper';

export default function Header() {
  const cx = classNames.bind(styles);
  const [simplebarRef] = useSimpleBar();
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);

  const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);
  const [logout] = useLogoutMutation();

  const toggleMenu = () => {
    setIsHamburgerMenuOpen(!isHamburgerMenuOpen);
  };

  const closeMenu = () => {
    setIsHamburgerMenuOpen(false);
  };

  const handleLogout = async () => {
    const accessToken = getAccessToken();
    setLocalStorage('loggedIn', 0);
    try {
      await logout({ accessToken }).unwrap();
      dispatch(apiSlice.util.resetApiState());
      deleteAllTokens();
      await persistor.purge();
    } catch (error) {
      console.log('Fail to Logout', error);
    }
  };

  return (
    <header
      className={cx('header--container', {
        'layer--open': isHamburgerMenuOpen,
      })}
      onMouseLeave={closeMenu}
    >
      <div className={cx('inner')}>
        <ConditionalWrapper
          condition={!isMobile}
          wrapper={(children) => (
            <SimpleBar forceVisible={true} ref={simplebarRef}>
              {children}
            </SimpleBar>
          )}
        >
          <>
            {!isMobile ? (
              <Logo
                wrapperClasses={[
                  'logo_area',
                  'header',
                  isHamburgerMenuOpen ? 'layer--open' : '',
                ]}
              />
            ) : (
              isHamburgerMenuOpen && (
                <div className={cx('drive_user')}>
                  <div className={cx('login_layer')}>
                    <span className={cx('user_id', 'text_clip')}>
                      <span>{user?.alias}</span>
                      {HONORIFIC_SUFFIX}
                    </span>
                    <div className={cx('flex')}>
                      <Link to="/home/settings/account" onClick={closeMenu}>
                        <span className={cx('user_email', 'text_clip')}>
                          {user?.email}
                        </span>
                      </Link>
                      <Link
                        to="/login"
                        className={cx('btn', 'logout')}
                        onClick={handleLogout}
                      >
                        <span>{LOGOUT}</span>
                      </Link>
                    </div>
                  </div>
                </div>
              )
            )}
            <Progress
              isOpenHamburgerMenu={isHamburgerMenuOpen}
              closeMenu={closeMenu}
            />
            <Navigation
              toggleMenu={toggleMenu}
              isHamburgerMenuOpen={isHamburgerMenuOpen}
            />
          </>
        </ConditionalWrapper>
      </div>
    </header>
  );
}
